<template>
  <v-container id="master-potensi-spasial" fluid tag="section" class="cyber-container">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-map-marker-radius"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-title">
              MODUL POTENSI SPASIAL
            </div>
            <div class="subtitle-1 font-weight-light secondary-text">
              Manajemen Data Koordinat & Kategori Potensi Wilayah
            </div>
          </template>

          <v-card-text class="mt-4">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="4">
                <v-btn class="cyber-btn-add" @click="openDialog()">
                  <v-icon left>mdi-plus-box-outline</v-icon> REGISTRASI POTENSI BARU
                </v-btn>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="filterKategori"
                  :items="kategoriOptions"
                  item-text="nama_kategori"
                  item-value="nama_kategori"
                  label="Filter per Kategori"
                  clearable
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-filter-variant"
                  class="cyber-search"
                  placeholder="Cari & pilih kategori..."
                  no-data-text="Kategori tidak ditemukan"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-database-search"
                  label="Cari Toponim atau Desa..."
                  single-line
                  hide-details
                  flat
                  solo-inverted
                  class="cyber-search"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filteredPotensi"
              :loading="loading"
              class="transparent-table"
            >
              <template v-slot:item.toponim="{ item }">
                <span class="white--text font-weight-bold text-uppercase">
                  {{ item.toponim }}
                </span>
              </template>

              <template v-slot:item.nama_kategori="{ item }">
                <v-chip small outlined color="#018C74" class="font-weight-medium">
                  {{ item.nama_kategori }}
                </v-chip>
              </template>

              <template v-slot:item.nama_jenis="{ item }">
                <v-chip small outlined color="#CFA22D" class="font-weight-medium">
                  {{ item.nama_jenis }}
                </v-chip>
              </template>

              <template v-slot:item.koordinat="{ item }">
                <span class="caption secondary-text">
                  X: {{ item.koordinat_x }} <br />
                  Y: {{ item.koordinat_y }}
                </span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="#018C74"
                  @click="openDialog(item)"
                  class="mx-1 glow-hover"
                >
                  <v-icon small>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="#ff5252"
                  @click="deleteItem(item)"
                  class="mx-1 glow-hover"
                >
                  <v-icon small>mdi-delete-variant</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px" persistent overlay-opacity="0.85">
      <v-card class="cyber-dialog">
        <v-card-title class="dialog-header">
          <v-icon left color="#CFA22D">mdi-form-select</v-icon>
          <span class="font-weight-bold white--text">{{ formTitle.toUpperCase() }}</span>
          <v-spacer />
          <v-btn icon @click="close" small ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-8 px-6">
          <v-text-field
            v-model="editedItem.toponim"
            label="Toponim / Nama Potensi"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-map-marker"
            class="cyber-input"
          />

          <v-text-field
            v-model="editedItem.alamat"
            label="Alamat Lengkap"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-map-marker-outline"
            class="cyber-input"
          />

          <v-text-field
            v-model="editedItem.pic"
            label="PIC / Penanggung Jawab"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-account-tie"
            class="cyber-input"
          />

          <v-autocomplete
            v-model="selectedKecamatan"
            :items="kecamatanOptions"
            label="Pilih Kecamatan (mempersempit daftar Desa)"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-city-variant-outline"
            class="cyber-input"
            clearable
            placeholder="Pilih kecamatan..."
            no-data-text="Kecamatan tidak ditemukan"
          />

          <v-autocomplete
            v-model="editedItem.desa_id"
            :items="desaOptionsFiltered"
            :search-input.sync="searchDesa"
            item-text="nama_desa"
            item-value="id"
            label="Pilih / Ketik Desa Baru"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-home-outline"
            class="cyber-input"
            clearable
            placeholder="Pilih atau ketik desa lalu tekan Enter..."
            @keydown.enter="addCustomDesa"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase yellow--text">
                    Tekan <kbd>Enter</kbd> untuk membuat desa baru:
                    <strong>"{{ searchDesa }}"</strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="editedItem.kategori_nama"
            :items="kategoriOptions"
            :search-input.sync="searchKategori"
            item-text="nama_kategori"
            item-value="nama_kategori"
            label="Pilih / Ketik Kategori Baru"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-format-list-bulleted"
            class="cyber-input"
            clearable
            placeholder="Pilih atau ketik kategori lalu tekan Enter..."
            @keydown.enter="addCustomKategori"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase yellow--text">
                    Tekan <kbd>Enter</kbd> untuk membuat kategori baru:
                    <strong>"{{ searchKategori }}"</strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="editedItem.master_id"
            :items="jenisOptions"
            :search-input.sync="searchJenis"
            item-text="nama_jenis"
            item-value="id"
            label="Pilih / Ketik Jenis Baru"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-shape-outline"
            class="cyber-input"
            :disabled="!editedItem.kategori_nama"
            :placeholder="
              editedItem.kategori_nama
                ? 'Pilih atau ketik jenis lalu tekan Enter...'
                : 'Silahkan pilih kategori dahulu'
            "
            clearable
            @keydown.enter="addCustomJenis"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase yellow--text">
                    Tekan <kbd>Enter</kbd> untuk membuat jenis baru:
                    <strong>"{{ searchJenis }}"</strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="editedItem.koordinat_x"
                label="Koordinat X (Longitude)"
                outlined
                color="#018C74"
                prepend-inner-icon="mdi-longitude"
                class="cyber-input"
                placeholder="Contoh: 113.8214"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="editedItem.koordinat_y"
                label="Koordinat Y (Latitude)"
                outlined
                color="#018C74"
                prepend-inner-icon="mdi-latitude"
                class="cyber-input"
                placeholder="Contoh: -7.9134"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <v-file-input
                v-model="fotoBaru"
                label="Upload Foto / Video (bisa lebih dari satu, maks 5)"
                multiple
                outlined
                color="#018C74"
                prepend-inner-icon="mdi-camera-plus-outline"
                accept="image/*,video/*"
                class="cyber-input"
                @change="handleFotoChange"
                hint="Maksimal 1 video, otomatis ditempatkan di urutan pertama. Maks total 5 file."
                persistent-hint
              />
            </v-col>
          </v-row>

          <v-row v-if="fotoPreview.length" class="mt-2">
            <v-col cols="12">
              <div class="caption secondary-text mb-2">
                PRATINJAU MEDIA ({{ fotoPreview.length }})
              </div>
              <div class="foto-preview-grid">
                <div
                  v-for="(media, idx) in fotoPreview"
                  :key="media.url + idx"
                  class="foto-preview-item"
                >
                  <v-chip
                    x-small
                    :color="media.type === 'video' ? '#CFA22D' : '#018C74'"
                    class="foto-badge"
                  >
                    {{ media.type === "video" ? "VIDEO" : "FOTO" }}
                    <span v-if="idx === 0 && media.type === 'video'"> • UTAMA</span>
                  </v-chip>

                  <video
                    v-if="media.type === 'video'"
                    :src="media.url"
                    class="foto-thumb"
                    muted
                  />
                  <img v-else :src="media.url" class="foto-thumb" />

                  <v-btn
                    icon
                    x-small
                    color="#ff5252"
                    class="foto-remove-btn"
                    @click="removeFoto(idx)"
                  >
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <div
                id="map-picker"
                style="height: 350px; border-radius: 8px; overflow: hidden"
              ></div>

              <div class="caption mt-2 text-center">
                Geser marker atau klik peta untuk memilih lokasi.
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-6">
          <v-btn text @click="close" class="white--text opacity-6">BATAL</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="cyber-btn-save" :loading="loading" @click="save">
            SIMPAN DATA
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default {
  data: () => ({
    map: null,
    marker: null,
    defaultCenter: [-7.9134, 113.8214],

    search: "",
    searchDesa: "",
    searchKategori: "",
    searchJenis: "",

    filterKategori: null,
    selectedKecamatan: null,
    loading: false,
    dialog: false,

    potensiList: [],
    desaOptions: [],
    kategoriOptions: [],
    jenisOptions: [],
    fotoBaru: [],
    fotoLama: [],
    fotoPreview: [],

    headers: [
      { text: "TOPONIM / NAMA", value: "toponim" },
      { text: "KATEGORI", value: "nama_kategori" },
      { text: "JENIS", value: "nama_jenis" },
      { text: "KECAMATAN", value: "nama_kecamatan" },
      { text: "DESA/WILAYAH", value: "nama_desa_raw" },
      { text: "ALAMAT", value: "alamat" },
      { text: "PIC", value: "pic" },
      { text: "KOORDINAT SPEKTRUM", value: "koordinat", sortable: false },
      { text: "AKSI", value: "actions", sortable: false, align: "end" },
    ],

    editedIndex: -1,
    editedItem: {
      id: null,
      master_id: null,

      desa_id: null,
      nama_desa_raw: "",
      nama_desa_baru: "",

      kategori_nama: "",
      nama_kategori_baru: "",

      nama_jenis_baru: "",

      toponim: "",
      alamat: "",
      pic: "",
      koordinat_x: "",
      koordinat_y: "",
    },

    defaultItem: {
      id: null,
      master_id: null,

      desa_id: null,
      nama_desa_raw: "",
      nama_desa_baru: "",

      kategori_nama: "",
      nama_kategori_baru: "",

      nama_jenis_baru: "",

      toponim: "",
      alamat: "",
      pic: "",
      koordinat_x: "",
      koordinat_y: "",
    },
  }),

  computed: {
    filteredPotensi() {
      let list = this.potensiList;

      if (this.filterKategori) {
        list = list.filter((item) => item.nama_kategori === this.filterKategori);
      }

      if (this.search) {
        const query = this.search.toLowerCase();
        list = list.filter(
          (item) =>
            (item.toponim && item.toponim.toLowerCase().includes(query)) ||
            (item.nama_desa_raw && item.nama_desa_raw.toLowerCase().includes(query)) ||
            (item.nama_kategori && item.nama_kategori.toLowerCase().includes(query)) ||
            (item.nama_jenis && item.nama_jenis.toLowerCase().includes(query))
        );
      }

      return list;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Tambah Potensi Spasial" : "Edit Potensi Spasial";
    },

    kecamatanOptions() {
      const unik = new Set();
      this.desaOptions.forEach((d) => {
        if (d.nama_kecamatan) unik.add(d.nama_kecamatan);
      });
      return Array.from(unik).sort();
    },

    desaOptionsFiltered() {
      if (!this.selectedKecamatan) return this.desaOptions;

      return this.desaOptions.filter((d) => d.nama_kecamatan === this.selectedKecamatan);
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initMap();
          }, 200);
        });
      } else {
        this.destroyMap();
      }
    },

    selectedKecamatan(val) {
      if (!this.editedItem.desa_id) return;

      const masihValid = this.desaOptionsFiltered.some(
        (d) => d.id === this.editedItem.desa_id
      );

      if (!masihValid) {
        this.editedItem.desa_id = null;
        this.editedItem.nama_desa_raw = "";
      }
    },

    async "editedItem.kategori_nama"(val, oldVal) {
      if (val !== oldVal) {
        this.editedItem.master_id = null;
        this.editedItem.nama_jenis_baru = "";
      }

      if (val) {
        await this.fetchJenisByKategori(val);
      } else {
        this.jenisOptions = [];
      }
    },

    "editedItem.koordinat_x"() {
      this.moveMarker();
    },

    "editedItem.koordinat_y"() {
      this.moveMarker();
    },
  },

  mounted() {
    this.fetchData();
    this.fetchMasterDesa();
    this.fetchKategori();
  },

  methods: {
    determineType(nameOrFile) {
      const name = nameOrFile.name || nameOrFile;
      if (nameOrFile.type) return nameOrFile.type.startsWith("video") ? "video" : "foto";
      const ext = String(name).split(".").pop().toLowerCase();
      const videoExt = ["mp4", "mov", "avi", "mkv", "webm"];
      return videoExt.includes(ext) ? "video" : "foto";
    },

    handleFotoChange(files) {
      if (!files || !files.length) {
        this.fotoBaru = [];
        return;
      }

      const totalNanti =
        this.fotoLama.length +
        this.fotoPreview.filter((f) => f.isNew).length +
        files.length;
      if (totalNanti > 5) {
        alert("Maksimal total 5 file (foto + video)");
        this.fotoBaru = [];
        return;
      }

      for (const file of files) {
        const type = this.determineType(file);

        const sudahAdaVideo =
          this.fotoPreview.some((m) => m.type === "video") ||
          this.fotoLama.some((f) => this.determineType(f) === "video");

        if (type === "video" && sudahAdaVideo) {
          alert(`Video "${file.name}" dilewati, hanya boleh 1 video per potensi.`);
          continue;
        }

        const item = {
          url: URL.createObjectURL(file),
          name: file.name,
          type,
          file,
          isNew: true,
        };

        if (type === "video") {
          this.fotoPreview.unshift(item);
        } else {
          this.fotoPreview.push(item);
        }
      }

      this.fotoBaru = [];
    },

    removeFoto(idx) {
      const item = this.fotoPreview[idx];

      if (item.isNew) {
        if (item.url) URL.revokeObjectURL(item.url);
      } else {
        this.fotoLama = this.fotoLama.filter((f) => f !== item.name);
      }

      this.fotoPreview.splice(idx, 1);
    },

    initMap() {
      let lat = parseFloat(this.editedItem.koordinat_y);
      let lng = parseFloat(this.editedItem.koordinat_x);

      if (isNaN(lat)) lat = this.defaultCenter[0];
      if (isNaN(lng)) lng = this.defaultCenter[1];

      if (this.map) {
        this.destroyMap();
      }

      this.map = L.map("map-picker").setView([lat, lng], 14);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap",
      }).addTo(this.map);

      this.marker = L.marker([lat, lng], {
        draggable: true,
      }).addTo(this.map);

      this.marker.on("dragend", () => {
        const pos = this.marker.getLatLng();
        this.editedItem.koordinat_y = pos.lat.toFixed(6);
        this.editedItem.koordinat_x = pos.lng.toFixed(6);
      });

      this.map.on("click", (e) => {
        this.marker.setLatLng(e.latlng);
        this.editedItem.koordinat_y = e.latlng.lat.toFixed(6);
        this.editedItem.koordinat_x = e.latlng.lng.toFixed(6);
      });

      setTimeout(() => {
        this.map.invalidateSize();
      }, 200);
    },

    destroyMap() {
      if (this.map) {
        this.map.remove();
        this.map = null;
        this.marker = null;
      }
    },

    moveMarker() {
      if (!this.map || !this.marker) return;

      const lat = parseFloat(this.editedItem.koordinat_y);
      const lng = parseFloat(this.editedItem.koordinat_x);

      if (isNaN(lat) || isNaN(lng)) return;

      this.marker.setLatLng([lat, lng]);
      this.map.panTo([lat, lng]);
    },

    async fetchMasterDesa() {
      try {
        let apiDesa = [];
        let localBps = [];

        try {
          const response = await axios.get(`${BASE_URL}/desa`);
          if (response.data && response.data.response) {
            apiDesa = response.data.response.data || [];
          }
        } catch (apiErr) {
          console.error("Gagal Muat API Desa, mencoba fallback ke local BPS...", apiErr);
        }

        try {
          const MASTER_CACHE_KEY = "master-init";
          const cache = localStorage.getItem(MASTER_CACHE_KEY);

          if (cache) {
            const parsed = JSON.parse(cache);
            const root =
              parsed?.response?.data?.data ||
              parsed?.data?.data ||
              parsed?.data ||
              parsed;

            const bpsList = Array.isArray(root?.bps) ? root.bps : [];

            localBps = bpsList.map((item) => ({
              id: item.id,
              kecamatan_id: item.id_kecamatan,
              nama_desa: item.desa ? item.desa.trim().toUpperCase() : "",
              nama_kecamatan: item.nama_kecamatan,
              kode_bps: item.kode_bps,
              is_bps: true,
            }));
          }
        } catch (localErr) {
          console.error("Gagal membaca cache BPS dari localStorage", localErr);
        }

        const gabunganDesa = [...apiDesa, ...localBps];
        const unikDesa = {};

        gabunganDesa.forEach((item) => {
          if (item.nama_desa) {
            const namaDesa = item.nama_desa.trim().toUpperCase();
            const namaKec = (item.nama_kecamatan || "").trim().toUpperCase();
            const namaKey = `${namaDesa}__${namaKec || "UNKNOWN"}`;

            if (!unikDesa[namaKey]) {
              unikDesa[namaKey] = item;
            } else if (!unikDesa[namaKey].nama_kecamatan && item.nama_kecamatan) {
              unikDesa[namaKey] = {
                ...unikDesa[namaKey],
                nama_kecamatan: item.nama_kecamatan,
              };
            }
          }
        });

        this.desaOptions = Object.values(unikDesa);
      } catch (e) {
        console.error("Gagal memproses integrasi master data desa", e);
      }
    },

    addCustomDesa() {
      if (!this.searchDesa || this.searchDesa.trim() === "") return;

      const value = this.searchDesa.trim().toUpperCase();

      const exists = this.desaOptions.find(
        (item) => item.nama_desa.toLowerCase() === value.toLowerCase()
      );

      if (!exists) {
        const newId = `NEW_DESA_${Date.now()}`;
        const newDesa = {
          id: newId,
          nama_desa: value,
          nama_kecamatan: this.selectedKecamatan || null,
          is_custom: true,
        };

        this.desaOptions.push(newDesa);
        this.editedItem.desa_id = newId;
        this.editedItem.nama_desa_raw = value;
        this.editedItem.nama_desa_baru = value;
      } else {
        this.editedItem.desa_id = exists.id;
        this.editedItem.nama_desa_raw = exists.nama_desa;
        this.editedItem.nama_desa_baru = "";
      }
    },

    async fetchKategori() {
      try {
        const res = await axios.get(`${BASE_URL}/master/potensi-master/kategori`);
        const rows = res?.data?.response?.data || [];
        this.kategoriOptions = rows.map((item) => ({
          nama_kategori: item.nama_kategori,
        }));
      } catch (e) {
        console.error("Gagal load kategori:", e);
      }
    },

    async fetchJenisByKategori(kategori) {
      try {
        if (!kategori) {
          this.jenisOptions = [];
          return;
        }

        const res = await axios.get(`${BASE_URL}/master/potensi-master/jenis`, {
          params: { kategori },
        });

        this.jenisOptions = res?.data?.response?.data || [];
      } catch (e) {
        console.error("Gagal load jenis by kategori:", e);
        this.jenisOptions = [];
      }
    },

    addCustomKategori() {
      if (!this.searchKategori || this.searchKategori.trim() === "") return;

      const value = this.searchKategori.trim();

      const exists = this.kategoriOptions.find(
        (item) => item.nama_kategori.toLowerCase() === value.toLowerCase()
      );

      if (!exists) {
        this.kategoriOptions.push({
          nama_kategori: value,
          is_custom: true,
        });
      }

      this.editedItem.kategori_nama = value;
      this.editedItem.nama_kategori_baru = value;

      this.editedItem.master_id = null;
      this.editedItem.nama_jenis_baru = "";
      this.searchJenis = "";
      this.jenisOptions = [];
    },

    addCustomJenis() {
      if (!this.searchJenis || this.searchJenis.trim() === "") return;
      if (!this.editedItem.kategori_nama && !this.editedItem.nama_kategori_baru) return;

      const value = this.searchJenis.trim();

      const exists = this.jenisOptions.find(
        (item) => item.nama_jenis.toLowerCase() === value.toLowerCase()
      );

      if (!exists) {
        const newId = `NEW_JENIS_${Date.now()}`;

        this.jenisOptions.push({
          id: newId,
          nama_kategori:
            this.editedItem.nama_kategori_baru || this.editedItem.kategori_nama,
          nama_jenis: value,
          is_custom: true,
        });

        this.editedItem.master_id = newId;
        this.editedItem.nama_jenis_baru = value;
      } else {
        this.editedItem.master_id = exists.id;
        this.editedItem.nama_jenis_baru = "";
      }
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/master/potensi-spasial`);
        if (res.data && res.data.response) {
          this.potensiList = res.data.response.data || [];
        }
      } catch (e) {
        console.error("Gagal load potensi spasial:", e);
      } finally {
        this.loading = false;
      }
    },

    async openDialog(item) {
      this.editedIndex = item ? this.potensiList.indexOf(item) : -1;
      this.selectedKecamatan = null;

      if (item) {
        this.editedItem = {
          id: item.id,
          master_id: item.master_id,
          desa_id: item.desa_id || null,
          nama_desa_raw: item.nama_desa_raw || "",
          nama_desa_baru: "",
          kategori_nama: item.nama_kategori || "",
          nama_kategori_baru: "",
          nama_jenis_baru: "",
          toponim: item.toponim || "",
          alamat: item.alamat || "",
          pic: item.pic || "",
          koordinat_x: item.koordinat_x,
          koordinat_y: item.koordinat_y,
        };

        this.fotoLama = Array.isArray(item.foto) ? [...item.foto] : [];
        this.fotoPreview = this.fotoLama.map((filename) => ({
          url: `${BASE_URL}/uploads/${filename}`,
          name: filename,
          type: this.determineType(filename),
          isNew: false,
        }));

        let foundDesa = null;
        if (item.desa_id) {
          foundDesa = this.desaOptions.find((d) => d.id === item.desa_id);
        }
        if (!foundDesa && item.nama_desa_raw) {
          foundDesa = this.desaOptions.find((d) => d.nama_desa === item.nama_desa_raw);
        }
        if (foundDesa) {
          this.editedItem.desa_id = foundDesa.id;
          if (foundDesa.nama_kecamatan) {
            this.selectedKecamatan = foundDesa.nama_kecamatan;
          }
        }

        if (item.nama_kategori) {
          await this.fetchJenisByKategori(item.nama_kategori);
        }
      } else {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.jenisOptions = [];
        this.fotoLama = [];
        this.fotoPreview = [];
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectedKecamatan = null;
        this.searchDesa = "";
        this.searchKategori = "";
        this.searchJenis = "";
        this.jenisOptions = [];

        this.fotoPreview.forEach((item) => {
          if (item.isNew && item.url) URL.revokeObjectURL(item.url);
        });
        this.fotoPreview = [];
        this.fotoLama = [];
        this.fotoBaru = [];
      });
    },

    async save() {
      if (!this.editedItem.toponim) return alert("Toponim wajib diisi!");
      if (!this.editedItem.kategori_nama && !this.editedItem.nama_kategori_baru) {
        return alert("Kategori wajib diisi!");
      }
      if (
        !this.editedItem.master_id &&
        !this.editedItem.nama_jenis_baru &&
        !this.searchJenis
      ) {
        return alert("Jenis wajib diisi!");
      }
      if (!this.editedItem.koordinat_x || !this.editedItem.koordinat_y) {
        return alert("Koordinat wajib diisi!");
      }

      this.loading = true;

      try {
        const desaIdRaw = this.editedItem.desa_id;
        const isRealDesaId =
          desaIdRaw !== null &&
          desaIdRaw !== undefined &&
          desaIdRaw !== "" &&
          !String(desaIdRaw).startsWith("NEW_") &&
          !isNaN(parseInt(desaIdRaw));

        if (isRealDesaId) {
          const selectedDesa = this.desaOptions.find(
            (d) => d.id === this.editedItem.desa_id
          );
          if (selectedDesa) this.editedItem.nama_desa_raw = selectedDesa.nama_desa;
        } else if (this.editedItem.nama_desa_baru) {
          this.editedItem.nama_desa_raw = this.editedItem.nama_desa_baru;
        }

        const formData = new FormData();
        formData.append("toponim", this.editedItem.toponim);
        formData.append("nama_desa_raw", this.editedItem.nama_desa_raw || "");

        if (isRealDesaId) {
          formData.append("desa_id", parseInt(desaIdRaw));
        }

        formData.append("koordinat_x", parseFloat(this.editedItem.koordinat_x));
        formData.append("koordinat_y", parseFloat(this.editedItem.koordinat_y));
        formData.append("alamat", this.editedItem.alamat || "");
        formData.append("pic", this.editedItem.pic || "");

        const masterId = this.editedItem.master_id;
        const isExistingMaster =
          masterId && !String(masterId).includes("NEW_") && !isNaN(parseInt(masterId));

        if (isExistingMaster) {
          formData.append("master_id", parseInt(masterId));
        } else {
          const kategoriFinal = (
            this.editedItem.nama_kategori_baru ||
            this.editedItem.kategori_nama ||
            this.searchKategori ||
            ""
          ).trim();

          const jenisFinal = (
            this.editedItem.nama_jenis_baru ||
            this.searchJenis ||
            ""
          ).trim();

          if (!kategoriFinal || !jenisFinal) {
            this.loading = false;
            return alert("Kategori dan jenis baru wajib diisi!");
          }

          formData.append("nama_kategori", kategoriFinal);
          formData.append("nama_jenis", jenisFinal);
        }

        this.fotoPreview
          .filter((f) => f.isNew)
          .forEach((f) => formData.append("foto", f.file));

        if (this.editedIndex > -1) {
          formData.append("foto_lama", JSON.stringify(this.fotoLama));
        }

        if (this.editedIndex > -1) {
          await axios.put(
            `${BASE_URL}/master/potensi-spasial/${this.editedItem.id}`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
        } else {
          await axios.post(`${BASE_URL}/master/potensi-spasial`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }

        await this.fetchKategori();

        const kategoriRefresh = this.editedItem.kategori_nama || null;
        if (kategoriRefresh) await this.fetchJenisByKategori(kategoriRefresh);

        await this.fetchData();
        this.close();
      } catch (e) {
        console.error("Gagal menyimpan data potensi spasial:", e);
        alert(
          e?.response?.data?.metadata?.message ||
            e?.response?.data?.message ||
            "Gagal menyimpan data potensi spasial"
        );
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus data potensi spasial dengan toponim: ${item.toponim}?`)) {
        try {
          await axios.delete(`${BASE_URL}/master/potensi-spasial/${item.id}`);
          await this.fetchData();
        } catch (e) {
          alert("Gagal menghapus");
        }
      }
    },
  },
};
</script>

<style scoped>
.foto-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 12px;
}
.foto-preview-item {
  position: relative;
  border: 1px solid rgba(1, 140, 116, 0.4);
  border-radius: 8px;
  overflow: hidden;
  background: rgba(0, 26, 22, 0.6);
}
.foto-thumb {
  width: 100%;
  height: 90px;
  object-fit: cover;
  display: block;
}
.foto-badge {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 2;
  font-weight: 700 !important;
}
.foto-remove-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6) !important;
}

.cyber-container {
  background: transparent;
}
.cyber-title {
  letter-spacing: 3px !important;
  text-shadow: 0 0 12px rgba(1, 140, 116, 0.4);
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
}
.opacity-6 {
  opacity: 0.6;
}
.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.transparent-table {
  background: transparent !important;
}
.transparent-table >>> th {
  color: #cfa22d !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-bottom: 2px solid #018c74 !important;
}
.cyber-btn-add {
  background: linear-gradient(45deg, #018c74, #004d40) !important;
  color: white !important;
  border: 1px solid #cfa22d !important;
  font-weight: 900;
  box-shadow: 0 0 15px rgba(1, 140, 116, 0.3) !important;
}
.cyber-btn-save {
  background-color: #cfa22d !important;
  color: #002616 !important;
  font-weight: 900 !important;
}
.glow-hover:hover {
  filter: drop-shadow(0 0 5px currentColor);
}
.cyber-dialog {
  background: rgba(0, 20, 18, 0.96) !important;
  border: 1px solid #018c74 !important;
}
.dialog-header {
  border-bottom: 1px solid rgba(1, 140, 116, 0.3);
  background: rgba(1, 140, 116, 0.1);
}
kbd {
  background-color: #333;
  color: #fff;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
